import React from 'react';
import EditorChrome from './EditorChrome';

const Archive = () => (
    <main className="container portfolio-shell inner-shell">
        <EditorChrome active="/Archive" />
        <section className="inner-editor">
            <a className="back-link" href="/">Back to homepage</a>
            <div className="page-heading">
                <p>;; Earlier experiments, coursework, games, and hardware</p>
                <h1>Project Archive</h1>
                <span>Older work kept as a record of technical range, prototyping, and hands-on engineering.</span>
            </div>
            <div className="archive-grid">
                <a className="archive-card" href="/University">
                    <span>01 / coursework</span>
                    <h2>University Projects</h2>
                    <p>Software engineering, embedded systems, security, data analysis, and electrical engineering coursework.</p>
                    <strong>Open buffer →</strong>
                </a>
                <a className="archive-card" href="/Personal">
                    <span>02 / experiments</span>
                    <h2>Personal Projects</h2>
                    <p>Games, PCB designs, electronics experiments, and side projects built outside formal research.</p>
                    <strong>Open buffer →</strong>
                </a>
            </div>
        </section>
    </main>
);

export default Archive;
